<div>
  <glxy-form-field appearance="outline">
    <input
      matInput
      placeholder="{{ 'INBOX.NEW_MESSAGE.ACCOUNT_NAME' | translate }}"
      [formControl]="control"
      name="contact"
      autocomplete="off"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto
      [displayWith]="displayAccountGroup"
      autoActiveFirstOption
      class="search-select-autocomplete"
    >
      <div class="option-container">
        @for (account of accounts$ | async; track account) {
          <mat-option [value]="account" class="mat-option-text">
            <span class="business-name">
              {{ account?.napData?.companyName }}
            </span>
            <br />
            <span class="business-address">
              {{ account.napData | formatAddressToString }}
            </span>
          </mat-option>
        }
      </div>
      <mat-option class="add-account-option">
        <a (click)="openCreateAccountForm()" data-action="clicked-show-add-contact-form">
          <mat-icon aria-hidden="false" aria-label="add contact">add</mat-icon>
          <span class="label">{{ 'INBOX.EMPTY.ADD_ACCOUNT' | translate }}</span>
        </a>
      </mat-option>
    </mat-autocomplete>
  </glxy-form-field>
</div>
